import { combineReducers } from 'redux'
import eventsReducer from './events'
import usersReducer from './users'
import selectedEventReducer from './selectedEvent'
import adminEventReducer from './adminEvent'
import alertsReducer from './alerts'
import userEventReducer from './userEvent'
import userGuestsReducer from './guests'

export default combineReducers({
  events: eventsReducer,
  users: usersReducer,
  selectedEvent: selectedEventReducer,
  adminEvent: adminEventReducer,
  alerts: alertsReducer,
  userEvent: userEventReducer,
  userGuests: userGuestsReducer,
})
